import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-alfred',
  standalone: true,
  imports: [
    RouterLink,
    FooterComponent,
    StaticSearchComponent,
    CommonHeaderComponent,
  ],
  templateUrl: './alfred.component.html',
  styleUrl: './alfred.component.scss',
})
export class AlfredComponent {
  constructor(private titleService: Title, private metaService: Meta) {
    this.titleService.setTitle(
      'Tropical Cyclone Alfred Travel Insurance Updates | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content: `Get the latest World2Cover travel insurance update on Tropical Cyclone Alfred. Learn about coverage, claims and travel disruptions.`,
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Tropical Cyclone Alfred Travel Insurance Updates | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'Get the latest World2Cover travel insurance update on Tropical Cyclone Alfred. Learn about coverage, claims and travel disruptions.',
    });
  }
}
